const en = {
	translation: {
		COMMON: {
			EMAIL: 'Email',
			EMAIL_REQUIRED: 'Email is required',
			PASSWORD: 'Password',
			PASSWORD_REQUIRED: 'Password is required',
			DELETE: 'Delete',
			CONFIRM: 'Confirm',
			VIEW: 'View',
			CHANGE: 'Change',
			DISCARD: 'Discard',
			BACK: 'Back',
			UPLOAD: 'Upload file',
			ADD: 'Add',
			CREATE: 'Create',
			SUCCESS: 'Success',
			ERROR: 'Error',
			OPS: 'ERROR',
			ERROR_OCCURRED: 'An error occurred while fetching data.',
			ACTIONS: 'Actions',
			UPDATE: 'Update',
			INVALID_PHONE: 'Invalid phone number',
			PHONE_NUMBER: 'Phone number',
			SAR: 'SAR',
			EDIT: 'Edit',
			SEARCH: 'Search',
			ID: 'ID',
			DOWNLOAD: 'Download',
			CANCEL: 'Cancel',
			N_A: 'N/A',
			NO_DATA: 'No Data',
			STATUS: 'Status',
			ONLY_PNG_JPG: 'Supports only PNG and JPG file formats.',
			ACTIVE: 'Active',
			INACTIVE: 'Inactive',
			VERIFY: 'Verify',
			PHONE_INVALID: ' Phone number is invalid',
			PHONE_REQUIRED: 'Phone number is required',
			PENDING: 'Pending',
			APPROVED: 'Approved',
			REJECTED: 'Rejected',
			CANCELED: 'Canceled',
			RELEASED: 'Released',
			BLOCKED: 'Blocked',
			UNDERREVIEW: 'Under Review',
			PHONEVERIFIED: 'Phone Verified',
			REJECT_REASON: 'Reject Reason',
			REJECT_REASON_REQUIRED: 'Reject reason is required',
			FIELD_REQUIRED: 'This field is required',
			NUMBERS_ONLY: 'Only Number is permitted',
			REJECT_REASON_LENGTH: 'Reject reason must be between 4 and 200 characters',
		},
		LOGIN: {
			TITLE: 'Hello our hero',
			SUBTITLE: 'Welcome to Tanaqul',
			REMEMBER_ME: 'Remember me',
			LOGIN: 'Login',
			OTP_VERIFICATION: 'OTP Verification',
			ENTER_OTP: 'Enter the OTP sent to your phone number',
			INVALID_OTP: 'Invalid OTP',
		},
		SIDEBAR: {
			SPLASH_SCREENS: 'Splash Screens',
			ROLES: 'Roles',
			ADMINS: 'Admins',
			CLIENTS: 'Clients',
			COUNTRIES: 'Countries',
			REGIONS: 'Regions',
			CITIES: 'Cities',
			DISTRICTS: 'Districts',
			CURRENCIES: 'Currencies',
			LANGUAGES: 'Languages',
			BANKS: 'Banks',
			SETTINGS: 'Settings',
			DASHBOARD: 'Dashboard',
			ORDERS: 'Orders',
			ADMIN_MANAGE: 'Admins Manage',
			GEOGRAPHIC: 'Geographic',
			FINANCE: 'Finance',
			SUBSCRIPTIONS: 'Subscriptions',
			MINORS: 'Minors',
			INCOMPETENTS: 'Incompetents',
			COMMERCIAL_ENTITIES: 'Commercial Entities',
		},
		SPLASH_SCREENS: {
			TITLE: 'Splash Screens Settings',
			REARRANGE: 'Rearrange',
			ADD_SCREEN: 'Add Screen',
			DELETE: 'Delete Splash Screen',
			DELETE_MODAL_DESCRIPTION: 'The splash screen will be permanently removed from your Tanaqul dashboard',
			DELETE_MODAL_NOTE: 'Please note that all data related to this splash screen will be permanently removed from our dashboard.',
			ADD_SPLASH_SCREEN: 'Add Splash Screen',
			INFORMATION: 'Information',
			ARABIC_TITLE: 'Title in Arabic',
			ARABIC_TITLE_REQUIRED: 'Title in Arabic is required',
			ENGLISH_TITLE: 'Title in English',
			ENGLISH_TITLE_REQUIRED: 'Title in English is required',
			ENGLISH_DESCRIPTION: 'Description in English',
			ENGLISH_DESCRIPTION_REQUIRED: 'Description in English is required',
			ARABIC_DESCRIPTION: 'Description in Arabic',
			ARABIC_DESCRIPTION_REQUIRED: 'Description in Arabic is required',
			MEDIA: 'Media',
			BACKGROUND_COLOR: 'Background color',
			DELETED: 'Splash Screen has been deleted',
			DELETE_ERROR: 'An error occurred while deleting the splash screen',
			SORTED: 'Splash Screens have been sorted',
			SORT_ERROR: 'An error occurred while sorting the splash screens',
		},
		ROLES: {
			TITLE: 'Role management',
			ROLES: 'Roles',
			MANAGE_ROLES: 'Manage your system roles',
			ROLE_NAME: 'Role name',
			DELETE_ROLE: 'Delete Role',
			DELETE_MODAL_DESCRIPTION: 'The role will be permanently removed from your Tanaqul dashboard',
			DELETE_MODAL_NOTE: 'Please note that all data related to this role will be permanently removed from our Dashboard',
			DELETED: 'Role has been deleted',
			DELETE_ERROR: 'An error occurred while deleting the role',
			ADD_NEW: 'Add New Role',
			ADMIN_ROLE_INF: 'Admin Role Information',
			ROLE_NAME_REQUIRED: 'Role name is required',
			ADMIN_ROLE: 'Admin Role',
			MODULE: 'Module',
			PROFILE: 'Profile',
			ROLE: 'Role',
			ADMIN: 'Admin',
			PERMISSION: 'Permission',
			LANGUAGE: 'Language',
			CURRENCY: 'Currency',
			COUNTRY: 'Country',
			REGION: 'Region',
			CITY: 'City',
			DISTRICT: 'District',
			WALLET: 'Wallet',
			MOBILE: 'Splash Screen',
			BANK: 'Bank',
			SETTING: 'Setting',
			SETTING_CATEGORY: 'Setting Category',
			USER: 'User',
			BALANCE: 'Balance',
			PAYMENT: 'Payment',
			ROLE_CREATED: 'Role created successfully',
			ROLE_ALREADY_EXIST: 'Role name already exist',
			ROLE_CREATE_ERROR: 'Error on create the role',
			UPDATE_ROLE: 'Update Role',
			ROLE_UPDATED: 'role updated successfully',
			ROLE_UPDATE_FAILED: 'An error occurred when updating the role',
			MINOR: 'Minors',
			INVESTMENT: 'Commercial Entities',
			INCOMPETENT: 'Incompetents',
		},
		USERS: {
			TITLE: 'Clients Portal',
			CLIENT: 'Client',
			CLIENTS: 'Clients',
			MANAGE_CLIENTS: 'Manage your system clients',
			CLIENT_ID: 'Client ID',
			NATIONAL_ID: 'National ID',
			REGISTRY_DATE: 'Register date	',
			STATUS: 'Status',
			ADD_CLIENT: 'Add new Client',
			CLIENT_DETAILS: 'Client details',
			NAME_ARABIC: 'Name in Arabic',
			ENTER_NAME_ARABIC: 'Enter name in Arabic',
			NAME_ENGLISH: 'Name in English',
			ENTER_NAME_ENGLISH: 'Enter name in English',
			ENTER_NATIONAL_ID: 'Enter national ID',
			DATE_OF_BIRTH: 'Date of birth',
			ENTER_DATE_BIRTH: 'Enter Date of birth',
			ADDRESS: 'Address',
			ENTER_ADDRESS: 'Enter address',
			PASSWORD: 'Password',
			ENTER_PASSWORD: 'Enter password',
			CONFIRM_PASSWORD: 'Confirm password',
			ENTER_CONFIRM_PASSWORD: 'Enter confirm password',
			LOCALE: 'Locale',
			COUNTRY: 'Country',
			AR_NAME_REQUIRED: "Please enter client's arabic name!",
			EN_NAME_REQUIRED: "Please enter client's english name!",
			NATIONAL_ID_REQUIRED: "Please enter client's national ID!",
			DATE_BIRTH_REQUIRED: "Please enter client's birth date!",
			CLIENT_ADDRESS_REQUIRED: "Please enter client's address!",
			CLIENT_PASSWORD_REQUIRED: "Please enter client's password!",
			CONFIRM_PASSWORD_REQUIRED: 'Please enter confirm password!',
			LOCAL_REQUIRED: "Please select client's locale!",
			COUNTRY_REQUIRED: "Please select client's country!",
			CLIENT_DELETED: 'Client deleted successfully',
			CLIENT_NOT_DELETED: 'Error on deleting selected client',
			DELETE_CLIENT: 'Delete Client',
			DELETE_MODAL_DESCRIPTION: 'The client will be permanently removed from your Tanaqul dashboard',
			DELETE_MODAL_NOTE: 'Please note that all data related to this client will be permanently removed from our Dashboard',
			CLIENT_CREATED: 'Client created successfully',
			CLIENT_NOT_CREATED: 'Error occurred when creating the client',
			MIN_12: 'Minimum number is 12 characters',
			MAX_60: 'Maximum number is 60 characters',
			NATIONAL_ID_10: 'The National ID must be 10 digits',
			PASSWORD_8_CHARS: 'The password must be at least 8 characters',
			FETCH_CLIENT_ERROR: 'Error when fetching client data',
			CLIENT_UPDATED: 'Client updated successfully',
			CLIENT_NOT_UPDATED: 'Error occurred when updating the client',
			UPDATE_CLIENT: 'Update Client',
			BLOCK_REASON: 'Block reason',
			BLOCK_REASON_REQUIRED: 'Block reason is required',
			ENTER_REASON: 'Enter reason',
			CHANGE_CLIENT_PASSWORD: 'Change Client Password',
			CHANGE_PASSWORD: 'Change password',
			PASSWORDS_NOT_MATCH: "Password and confirm password don't match",
			CLIENT_PASSWORD_UPDATED: 'Client password updated successfully',
			CLIENT_PASSWORD_NOT_UPDATED: 'Error occurred when updating the client password',
			SHARE_TRANSACTIONS: 'Share Transactions',
			INVESTMENTS: 'Investments',
			COMPANIES: 'Companies',
			WALLET_TRANSACTIONS: 'Wallet Transactions',
			BANK_ACCOUNTS: 'Bank Accounts',
			PAYMENTS: 'Payments',
			WITHDRAW_REQUESTS: 'Withdraw Requests',
			POINT_WALLET_TRANSACTIONS: 'Point Wallet Transactions',
			AVAILABLE_BUYING_POWER: 'Available Buying Power',
			AVAILABLE_WITHDRAW: 'Available Withdraw',
			TYPE: 'Type',
			COMPANY_NAME: 'Company Name',
			COMPANY_CODE: 'Company Code',
			ROLE: 'Role',
			STATUS_KEY: 'status Key',
			DATE: 'Date',
			QUANTITY: 'Quantity',
			PRICE_SHARE: 'Price/Share',
			ACTION: 'Action',
			ALL: 'All',
			PENDING: 'Pending',
			REJECTED: 'Rejected',
			CANCELED: 'Canceled',
			EXPIRED: 'Expired',
			COMPLETED: 'Completed',
			COMPANY_COUNTRY: 'Company Country',
			COMPANY_SECTOR: 'Company Sector',
			TRANSACTION_ROLE: 'Transaction Role',
			SELLER_NATIONAL_ID: 'Seller National Id',
			ORDER_TYPE: 'Order Type',
			ALL_OR_NONE: 'All Or None',
			DATE_AND_TIME: 'Date And Time',
			EXPIRY: 'Expiry',
			PRICE_PER_SHARE: 'Price Per Share',
			TOTAL_SUM: 'Total Sum',
			COMMISSION: 'Commission',
			VAT_PERCENTAGE: 'Vat Percentage',
			VAT: 'VAT',
			ESTIMATED_ORDER_VALUE: 'Estimated Order Value',
			SELLER_ACCEPTED: 'Seller Accepted',
			BUYER_ACCEPTED: 'Buyer Accepted',
			ACCEPTED: 'Accepted',
			DECLINED: 'Not accepted',
			COMPANY_LOGO: 'Company Logo',
			AVERAGE_BUYING_PRICE: 'Average buying price',
			FOUNDER: 'Founder',
			EXECUTIVE: 'Executive',
			BOARD_OF_DIRECTORS: 'Board Of Directors',
			DETAILS: 'Details',
			OVERVIEW: 'Overview',
			DOCUMENTS: 'Documents',
			COMMON_SHARE_COUNT: 'Common Shares Count',
			EQUITY_PERCENTAGE: 'Equity Percentage',
			FREE_COMMON_SHARE_COUNT: 'Free Common Shares Count',
			FREE_PREFERRED_SHARE_COUNT: 'Free Preferred Shares Count',
			FILLY_PAID: 'Fully Paid',
			MORTGAGE_COMMON_SHARES_COUNT: 'Mortgaged Common Shares Count',
			MORTGAGE_PREFERRED_SHARES_COUNT: 'Mortgaged Preferred Shares Count',
			OFFERED_COMMON_SHARES_COUNT: 'Offered Common Shares Count',
			PREFERRED_SHARES_COUNT: 'Preferred Shares Count',
			PURCHASE_COST: 'Purchase Cost',
			SUSPEND_COMMON_SHARES_COUNT: 'Suspended Common Shares Count',
			SUSPEND_PREFERRED_SHARES_COUNT: 'Suspended Preferred Shares Count',
			COMPANY_DOCUMENTS: "{{name}}'s Documents",
			AVERAGE_SHARE_PRICE: 'Average Share Price',
			DAILY_VOLUME: 'Daily Volume',
			DAILY_VALUE: 'Daily Value',
			COMPANY_MANAGER_NAME: 'Company Manager Name',
			DESCRIPTION: 'Description',
			SIZE: 'Size',
			MB: 'MB',
			KB: 'KB',
			AMOUNT: 'Amount',
			NAME: 'Name',
			BANK: 'Bank',
			LOGO: 'Bank Logo',
			GATEWAY: 'Gateway',
			REFERENCE: 'Reference',
			INVOICE_NO: 'Invoice no.',
			EXPIRE: 'Expire',
			BILLER_CODE: 'Biller code',
			BILLER_NAME: 'Biller name',
			UPDATE_TIME: 'Update time',
			REJECTION_REASON: 'Rejection Reason',
			REJECTION_REASON_REQUIRED: 'Rejection reason is required',
			ACCOUNT_NAME: 'Account name',
			COMPLETE_THE_REQUEST: 'Complete the request',
			ARE_YOU_SURE_TO_COMPLETE: 'Are you sure to complete this withdraw request?',
			DELETE_THE_REQUEST: 'Delete the request',
			ARE_YOU_SURE_TO_DELETE: 'Are you sure to delete this withdraw request?',
			WITHDRAW_COMPLETED: 'Withdraw request with id ( {{requestId}} ) completed',
			WITHDRAW_NOT_COMPLETED: 'An error occurred when completing withdraw request with id ( {{requestId}} )',
			WITHDRAW_DELETED: 'Withdraw request with id ( {{requestId}} ) deleted',
			WITHDRAW_NOT_DELETED: 'An error occurred when deleting withdraw request with id ( {{requestId}} )',
			WITHDRAW_REJECTED: 'Withdraw request with id ( {{requestId}} ) rejected',
			WITHDRAW_NOT_REJECTED: 'An error occurred when rejecting withdraw request with id ( {{requestId}} )',
			DELETE_WITHDRAW_REQUEST: 'Deleting withdraw request with id ( {{requestId}} )',
			BASE_AMOUNT: 'Base Amount',
			VAT_AMOUNT: 'VAT Amount',
			LAST_UPDATE: 'Last Update',
			CURRENCY: 'Currency',
			EMAIL: 'Email',
			EMAIL_REQUIRED: 'Email is required',
			EMAIL_NOT_VALID: 'Email not valid',
			ENTER_EMAIL: 'Enter a valid email',
			READ_LAST_AGREEMENT: 'Read Last Agreement',
			SEARCH: 'Search by Name, National ID or Phone number',
			SIGNATURE: 'Signature',
			CHARGE: 'Charge',
			CHARGE_POINTS: 'Charge Points',
			CHARGE_POINTS_FOR_USER: 'Charge Points for User',
			SELECT_CHARGE_POINTS_AMOUNT: 'Select Charge Points Amount',
			USER_WALLET_SUCCESS: 'User wallet charged successfully',
			ERROR_OCCURRED_CHARGE: 'An error occurred when charging user wallet',
		},
		ADMINS: {
			PASSWORD_UPDATED: 'Admin password changed',
			PASSWORD_NOT_UPDATED: 'An error occurred when changing admin password',
			PASSWORD_8_CHARS: 'The password must be at least 8 characters',
			PASSWORD_REQUIRED: 'password is required',
			CONFIRM_PASSWORD_REQUIRED: 'Confirm password is required',
			AUTHOR: 'Author',
			ROLES: 'Roles',
			ADMIN_DELETED: 'Admin deleted',
			ADMIN_NOT_DELETED: 'An error occurred when deleing the admin',
			ADMINS_MANAGEMENT: 'Admins management',
			ADMINS: 'Admins',
			INVITE_ADMINS_AND_MANAGE_ACCESS: 'Invite admins and manage their access to your account.',
			INVITE_ADMINS: 'Invite admins',
			DELETE_ADMIN: 'DELETE_ADMIN',
			DELETE_MODAL_DESCRIPTION: 'The admin will be permanently removed from your Tanaqul dashboard',
			DELETE_MODAL_NOTE: 'Please note that all data related to this admin will be permanently removed from our dashboard.',
			CREATED: 'Admin created successfully',
			NOT_CREATED: 'An error occurred when adding the admin',
			ADD_NEW_ADMIN: 'Add New Admin',
			INFORMATION: 'Information',
			FULL_NAME: 'Full name',
			FULL_NAME_REQUIRED: 'Full name is required',
			EMAIL: 'Email',
			EMAIL_REQUIRED: 'Email is required',
			EMAIL_NOT_VALID: 'Email is not valid',
			PASSWORD: 'Password',
			AVATAR: 'Avatar',
			ADMIN_ROLES: 'Admin Roles',
			SEND_STAFF_INVITATION: 'Send a staff invitation',
			ADMIN_STATUS_CHANGED: 'Admin status changed',
			ADMIN_STATUS_NOT_CHANGED: 'An error occurred when updating admin status',
			ADMIN_UPDATED: 'The admin data has been successfully updated',
			ADMIN_NOT_UPDATED: 'An error occurred when updating admin data',
			EDIT_ADMIN: 'Edit Admin',
			ACTIVATE: 'Activate',
			DEACTIVATE: 'Deactivate',
			ADMIN_DETAILS: 'Admin Details',
		},
		COUNTRIES: {
			NAME: 'Country Name',
			COUNTRIES: 'Countries',
			DELETE_TITLE: 'Delete Country',
			DELETE_DESCRIPTION: 'The country will be permanently removed from your Tanaqoul dashboard.',
			DELETE_NOTE: 'Please note that all data related to this country will be permanently removed from our Dashboard.',
			MANAGEMENT: 'Countries Management',
			DELETE_ERROR: 'Error on deleting selected country',
			DELETED_SUCCESS: 'Country deleted successfully',
			MANAGE_DESCRIPTION: 'Manage your system countries',
			CREATE_TITLE: 'Add New Country',
			DETAILS: 'Country Details',
			INFORMATION: 'Information',
			FLAG: 'Country Flag',
			PLACEHOLDER: {
				NAME_EN: 'Name in English',
				NAME_AR: 'Name in Arabic',
				CODE: 'Country Code',
			},
			VALIDATION: {
				NAME_EN: 'Please enter the English name!',
				NAME_AR: 'Please enter the Arabic name!',
				CODE: 'Please enter the country code!',
			},
			CREATED_SUCCESS: 'Country created successfully',
			CREATE_ERROR: 'Error occurred when adding the country',
			UPDATE_TITLE: 'Update Country',
			UPDATED_SUCCESS: 'Country updated successfully',
			FETCH_ERROR: 'Error fetching country data',
			UPDATE_ERROR: 'Error occurred when updating the country',
		},
		REGIONS: {
			CREATE_TITLE: 'Add New Region',
			DETAILS: 'Region Details',
			INFORMATION: 'Information',
			COUNTRY: 'Country',
			PLACEHOLDER: {
				NAME_EN: 'Name in English',
				NAME_AR: 'Name in Arabic',
			},
			VALIDATION: {
				NAME_EN: "Please enter the region's English name!",
				NAME_AR: "Please enter the region's Arabic name!",
				COUNTRY: 'Please select a country!',
			},
			CREATED_SUCCESS: 'Region created successfully',
			CREATE_ERROR: 'Error occurred while creating the region',
			MANAGEMENT_TITLE: 'Regions Management',
			MANAGEMENT_COUNT: 'Regions',
			MANAGEMENT_DESCRIPTION: 'Manage your system regions',
			NAME: 'Region Name',
			DELETE_TITLE: 'Delete Region',
			DELETE_DESCRIPTION: 'The region will be permanently removed from your system.',
			DELETE_NOTE: 'Please note that all data related to this region will be permanently removed.',
			DELETED_SUCCESS: 'Region deleted successfully',
			DELETE_ERROR: 'Error occurred while deleting the region',
			UPDATE_TITLE: 'Update Region',
			UPDATED_SUCCESS: 'Region updated successfully',
			FETCH_ERROR: 'Error fetching region data',
			UPDATE_ERROR: 'Error occurred while updating the region',
		},
		CITIES: {
			CREATE_TITLE: 'Add New City',
			DETAILS: 'City Details',
			INFORMATION: 'Information',
			REGION: 'Region',
			PLACEHOLDER: {
				NAME_EN: 'Name in English',
				NAME_AR: 'Name in Arabic',
			},
			VALIDATION: {
				NAME_EN: "Please enter the city's English name!",
				NAME_AR: "Please enter the city's Arabic name!",
				REGION: 'Please select a region!',
			},
			CREATED_SUCCESS: 'City created successfully',
			CREATE_ERROR: 'Error occurred while creating the city',
			MANAGEMENT_TITLE: 'Cities Management',
			MANAGEMENT_COUNT: 'Cities',
			MANAGEMENT_DESCRIPTION: 'Manage your system cities',
			NAME: 'City Name',
			DELETE_TITLE: 'Delete City',
			DELETE_DESCRIPTION: 'The city will be permanently removed from your system.',
			DELETE_NOTE: 'Please note that all data related to this city will be permanently removed.',
			DELETED_SUCCESS: 'City deleted successfully',
			DELETE_ERROR: 'Error occurred while deleting the city',
			UPDATE_TITLE: 'Update City',
			UPDATED_SUCCESS: 'City updated successfully',
			FETCH_ERROR: 'Error fetching city data',
			UPDATE_ERROR: 'Error occurred while updating the city',
		},
		DISTRICTS: {
			MANAGEMENT_TITLE: 'Districts Management',
			MANAGEMENT_COUNT: 'Districts',
			MANAGEMENT_DESCRIPTION: 'Manage your system districts',
			NAME: 'District Name',
			DELETED_SUCCESS: 'District deleted successfully',
			DELETE_TITLE: 'Delete District',
			DELETE_DESCRIPTION: 'The district will be permanently removed from your system.',
			DELETE_NOTE: 'Please note that all data related to this district will be permanently removed.',
			DELETE_ERROR: 'Error occurred while deleting the district',
			CREATE_TITLE: 'Add New District',
			DETAILS: 'District Details',
			INFORMATION: 'Information',
			CITY: 'City',
			PLACEHOLDER: {
				NAME_EN: 'Name in English',
				NAME_AR: 'Name in Arabic',
			},
			VALIDATION: {
				NAME_EN: "Please enter the district's English name!",
				NAME_AR: "Please enter the district's Arabic name!",
				CITY: 'Please select a city!',
			},
			CREATED_SUCCESS: 'District created successfully',
			CREATE_ERROR: 'Error occurred while creating the district',
			UPDATE_TITLE: 'Update District',
			UPDATED_SUCCESS: 'District updated successfully',
			UPDATE_ERROR: 'Error occurred while updating the district',
			FETCH_ERROR: 'Error fetching district data',
		},
		SUBSCRIPTIONS: {
			TITLE: 'Subscriptions',
			COUNT: 'Subscriptions',
			MANAGE_SUBSCRIPTIONS: 'Manage your system subscriptions',
			USER: 'User',
			TYPE: 'Type',
			POINTS: 'Points',
			BASE_AMOUNT: 'Base Amount',
			VAT_AMOUNT: 'VAT Amount',
			TOTAL_AMOUNT: 'Total Amount',
			BALANCE: 'Balance',
			VAT: 'VAT',
			TOTAL: 'Total',
			CURRENCY: 'Currency',
			DATE: 'Date',
			DESCRIPTION: 'Description',
		},
		CURRENCIES: {
			CREATE_TITLE: 'Add New Currency',
			DETAILS: 'Currency Details',
			SET_AS_DEFAULT: 'Set as Default',
			PLACEHOLDER: {
				NAME_EN: 'Name in English',
				NAME_AR: 'Name in Arabic',
				CODE: 'Code',
			},
			VALIDATION: {
				NAME_EN: "Please enter the currency's English name!",
				NAME_AR: "Please enter the currency's Arabic name!",
				CODE: 'Please enter the currency code!',
				CODE_LENGTH: 'Currency code length must be 3 characters',
			},
			CREATED_SUCCESS: 'Currency created successfully',
			CREATE_ERROR: 'Error occurred while creating the currency',
			MANAGEMENT_TITLE: 'Currencies Management',
			MANAGEMENT_COUNT: 'Currencies',
			MANAGEMENT_DESCRIPTION: 'Manage your system currencies',
			NAME: 'Currency Name',
			CODE: 'Code',
			DEFAULT: 'Default',
			DELETED_SUCCESS: 'Currency deleted successfully',
			DELETE_TITLE: 'Delete Currency',
			DELETE_DESCRIPTION: 'The currency will be permanently removed from your system.',
			DELETE_NOTE: 'Please note that all data related to this currency will be permanently removed.',
			DELETE_ERROR: 'Error occurred while deleting the currency',
			UPDATE_TITLE: 'Update Currency',
			UPDATED_SUCCESS: 'Currency updated successfully',
			UPDATE_ERROR: 'Error occurred while updating the currency',
			FETCH_ERROR: 'Error fetching currency data',
		},
		BANKS: {
			MANAGEMENT_TITLE: 'Banks Management',
			MANAGEMENT_COUNT: 'Banks',
			MANAGEMENT_DESCRIPTION: 'Manage your system banks',
			NAME: 'Bank Name',
			DELETED_SUCCESS: 'Bank deleted successfully',
			DELETE_TITLE: 'Delete Bank',
			DELETE_DESCRIPTION: 'The bank will be permanently removed from your system.',
			DELETE_NOTE: 'Please note that all data related to this bank will be permanently removed.',
			DELETE_ERROR: 'Error occurred while deleting the bank',
			CREATE_TITLE: 'Add New Bank',
			DETAILS: 'Bank Details',
			INFORMATION: 'Information',
			LOGO: 'Bank Logo',
			PLACEHOLDER: {
				NAME_EN: 'Name in English',
				NAME_AR: 'Name in Arabic',
			},
			VALIDATION: {
				NAME_EN: "Please enter the bank's English name!",
				NAME_AR: "Please enter the bank's Arabic name!",
			},
			CREATED_SUCCESS: 'Bank created successfully',
			CREATE_ERROR: 'Error occurred while creating the bank',
			UPDATE_TITLE: 'Update Bank',
			UPDATED_SUCCESS: 'Bank updated successfully',
			UPDATE_ERROR: 'Error occurred while updating the bank',
			FETCH_ERROR: 'Error fetching bank data',
		},
		LANGUAGES: {
			MANAGEMENT_TITLE: 'Languages Management',
			MANAGEMENT_COUNT: 'Languages',
			MANAGEMENT_DESCRIPTION: 'Manage your system languages',
			NAME: 'Language Name',
			DEFAULT: 'Default',
			DELETED_SUCCESS: 'Language deleted successfully',
			DELETE_TITLE: 'Delete Language',
			DELETE_DESCRIPTION: 'The language will be permanently removed from your system.',
			DELETE_NOTE: 'Please note that all data related to this language will be permanently removed.',
			DELETE_ERROR: 'Error occurred while deleting the language',
			CREATE_TITLE: 'Add New Language',
			DETAILS: 'Language Details',
			INFORMATION: 'Information',
			FLAG: 'Language Flag',
			PLACEHOLDER: {
				NAME: 'Language Name',
				CODE: 'Language Code',
			},
			VALIDATION: {
				NAME: 'Please enter the language name!',
				CODE: 'Please enter the language code!',
			},
			CREATED_SUCCESS: 'Language created successfully',
			CREATE_ERROR: 'Error occurred while creating the language',
			UPDATE_TITLE: 'Update Language',
			UPDATED_SUCCESS: 'Language updated successfully',
			UPDATE_ERROR: 'Error occurred while updating the language',
			FETCH_ERROR: 'Error fetching language data',
		},
		SETTINGS: {
			MANAGEMENT_TITLE: 'Settings Management',
			SPLASH_SCREENS: 'Splash Screens',
		},
		MINORS: {
			THE_MINORS: 'Minors',
			MINORS: 'Minors',
			MINOR: 'Minor',
			MINOR_ID: 'Minor ID',
			GARDIAN: 'Gardian',
			FAMILY_ID_DOCUMENT: 'Family ID Document',
			CUSTODY_ORDER_DOCUMENT: 'Custody Order Document',
			DELETE_TITLE: 'Delete Minor',
			DELETE_DESCRIPTION: 'The minor will be permanently removed from your Tanaqoul dashboard.',
			DELETE_NOTE: 'Please note that all data related to this minor will be permanently removed from our Dashboard.',
			MANAGEMENT_DESCRIPTION: 'Manage minors in your system',
			DELETE_ERROR: 'Error on deleting selected minor',
			DELETED_SUCCESS: 'Minor deleted successfully',
			MINOR_APPROVED: 'Minor approved successfully',
			MINOR_NOT_APPROVED: 'Error occurred when approving the minor',
			MINOR_REJECTED: 'Minor rejected successfully',
			MINOR_NOT_REJECTED: 'Error occurred when rejecting the minor',
			MINOR_UNLINKED: 'Minor unlinked successfully',
			MINOR_NOT_UNLINKED: 'Error occurred when unlinking the minor',
			MANAGE_DESCRIPTION: 'Manage your system minors',
			CREATE_TITLE: 'Add New Minor',
			DETAILS: 'Minor Details',
			CREATED_SUCCESS: 'Minor created successfully',
			CREATE_ERROR: 'Error occurred when adding the minor',
			UPDATE_TITLE: 'Update Minor',
			UPDATED_SUCCESS: 'Minor updated successfully',
			FETCH_ERROR: 'Error fetching minor data',
			UPDATE_ERROR: 'Error occurred when updating the minor',
			APPROVE: 'Approve',
			REJECT: 'Reject',
			UNLINK: 'Unlink',
			UNLINK_TITLE: 'Unlink Minor',
			UNLINK_DESCRIPTION: 'Are you sure you want to unlink this minor from their guardian?',
			APPROVE_TITLE: 'Approve Minor',
			APPROVE_DESCRIPTION: 'Are you sure you want to approve this minor?',
			REJECT_TITLE: 'Reject Minor',
			REJECT_DESCRIPTION: 'Are you sure you want to reject this minor?',
			MINOR_DETAILS: 'Minor Details',
			GARDIAN_DETAILS: 'Gardian Details',
			PENDING: 'Pending',
			APPROVED: 'Approved',
			REJECTED: 'Rejected',
			CANCELED: 'Canceled',
			RELEASED: 'Released',
			BLOCKED: 'Blocked',
			UNDERREVIEW: 'Under Review',
		},
		INCOMPETENTS: {
			INCOMPETENTS: 'Incompetents',
			INCOMPETENT: 'Incompetent',
			INCOMPETENT_ID: 'Incompetent ID',
			GARDIAN: 'Gardian',
			FAMILY_ID_DOCUMENT: 'Family ID Document',
			CUSTODY_ORDER_DOCUMENT: 'Custody Order Document',
			GUARDIANSHIP_ORDER_DOCUMENT: 'Guardianship Order Document',
			DELETE_TITLE: 'Delete Incompetent',
			DELETE_DESCRIPTION: 'The incompetent will be permanently removed from your Tanaqoul dashboard.',
			DELETE_NOTE: 'Please note that all data related to this incompetent will be permanently removed from our Dashboard.',
			MANAGEMENT_DESCRIPTION: 'Manage incompetents in your system',
			DELETE_ERROR: 'Error on deleting selected incompetent',
			DELETED_SUCCESS: 'Incompetent deleted successfully',
			INCOMPETENT_APPROVED: 'Incompetent approved successfully',
			INCOMPETENT_NOT_APPROVED: 'Error occurred when approving the incompetent',
			INCOMPETENT_REJECTED: 'Incompetent rejected successfully',
			INCOMPETENT_NOT_REJECTED: 'Error occurred when rejecting the incompetent',
			INCOMPETENT_UNLINKED: 'Incompetent unlinked successfully',
			INCOMPETENT_NOT_UNLINKED: 'Error occurred when unlinking the incompetent',
			MANAGE_DESCRIPTION: 'Manage your system incompetents',
			DETAILS: 'Incompetent Details',
			CREATED_SUCCESS: 'Incompetent created successfully',
			CREATE_ERROR: 'Error occurred when adding the incompetent',
			FETCH_ERROR: 'Error fetching incompetent data',
			UPDATE_ERROR: 'Error occurred when updating the incompetent',
			APPROVE: 'Approve',
			REJECT: 'Reject',
			UNLINK: 'Unlink',
			UNLINK_TITLE: 'Unlink Incompetent',
			UNLINK_DESCRIPTION: 'Are you sure you want to unlink this incompetent from their guardian?',
			APPROVE_TITLE: 'Approve Incompetent',
			APPROVE_DESCRIPTION: 'Are you sure you want to approve this incompetent?',
			REJECT_TITLE: 'Reject Incompetent',
			REJECT_DESCRIPTION: 'Are you sure you want to reject this incompetent?',
			INCOMPETENT_DETAILS: 'Incompetent Details',
			GARDIAN_DETAILS: 'Gardian Details',
		},
		COMMERCIAL_ENTITIES: {
			COMMERCIAL_ENTITIES: 'Commercial Entities',
			COMMERCIAL_ENTITY: 'Commercial Entity',
			COMMERCIAL_ENTITY_ID: 'Commercial Entity ID',
			GARDIAN: 'Guardian',
			FAMILY_ID_DOCUMENT: 'Family ID Document',
			CUSTODY_ORDER_DOCUMENT: 'Custody Order Document',
			DELETE_TITLE: 'Delete Commercial Entity',
			DELETE_DESCRIPTION: 'The commercial entity will be permanently removed from your Tanaqoul dashboard.',
			DELETE_NOTE: 'Please note that all data related to this commercial entity will be permanently removed from our Dashboard.',
			MANAGEMENT_DESCRIPTION: 'Manage commercial entities in your system',
			DELETE_ERROR: 'Error on deleting selected commercial entity',
			DELETED_SUCCESS: 'Commercial entity deleted successfully',
			COMMERCIAL_ENTITY_APPROVED: 'Commercial entity approved successfully',
			COMMERCIAL_ENTITY_NOT_APPROVED: 'Error occurred when approving the commercial entity',
			COMMERCIAL_ENTITY_REJECTED: 'Commercial entity rejected successfully',
			COMMERCIAL_ENTITY_NOT_REJECTED: 'Error occurred when rejecting the commercial entity',
			COMMERCIAL_ENTITY_UNLINKED: 'Commercial entity unlinked successfully',
			COMMERCIAL_ENTITY_NOT_UNLINKED: 'Error occurred when unlinking the commercial entity',
			MANAGE_DESCRIPTION: 'Manage your system commercial entities',
			DETAILS: 'Commercial Entity Details',
			CREATED_SUCCESS: 'Commercial entity created successfully',
			CREATE_ERROR: 'Error occurred when adding the commercial entity',
			FETCH_ERROR: 'Error fetching commercial entity data',
			UPDATE_ERROR: 'Error occurred when updating the commercial entity',
			APPROVE: 'Approve',
			REJECT: 'Reject',
			UNLINK: 'Unlink',
			UNLINK_TITLE: 'Unlink Commercial Entity',
			UNLINK_DESCRIPTION: 'Are you sure you want to unlink this commercial entity from their guardian?',
			APPROVE_TITLE: 'Approve Commercial Entity',
			APPROVE_DESCRIPTION: 'Are you sure you want to approve this commercial entity?',
			REJECT_TITLE: 'Reject Commercial Entity',
			REJECT_DESCRIPTION: 'Are you sure you want to reject this commercial entity?',
			COMMERCIAL_ENTITY_DETAILS: 'Commercial Entity Details',
			GARDIAN_DETAILS: 'Guardian Details',
			UNIFIED_CR: 'Unified CR',
			UNIFIED_CR_10: 'Unified CR must be 10 digits',
			CR_NUMBER: 'CR Number',
			CR_NUMBER_10: 'CR Number must be 10 digits',
			CR_DOCUMENT: 'CR Document',
			APPROVED_AUTHORIZED_DOCUMENT: 'Approved Authorized Document',
			PENDING: 'Pending',
			APPROVED: 'Transferred',
			REJECTED: 'Rejected',
			CANCELED: 'Canceled',
			RELEASED: 'Released',
			BLOCKED: 'Blocked',
			UNDERREVIEW: 'Under Review',
			UPDATE_TITLE: 'Update Commercial Entity',
			UPDATED_SUCCESS: 'Commercial entity updated successfully',
			NAME_AR: 'Name in Arabic',
			NAME_EN: 'Name in English',
			NAME_AR_REQUIRED: 'Name in Arabic is required',
			NAME_EN_REQUIRED: 'Name in English is required',
		},
	},
};

export default en;
